// src/types.ts
var PointRiskLevel = /* @__PURE__ */ ((PointRiskLevel2) => {
  PointRiskLevel2["NORMAL"] = "normal";
  PointRiskLevel2["MONITOR"] = "monitor";
  PointRiskLevel2["WARNING"] = "warning";
  PointRiskLevel2["HIGH_RISK"] = "high_risk";
  PointRiskLevel2["CRITICAL"] = "critical";
  return PointRiskLevel2;
})(PointRiskLevel || {});
var MarkNamespace;
((MarkNamespace2) => {
  let Type2;
  ((Type3) => {
    Type3["MOLE"] = "mole";
    Type3["FRECKLE"] = "freckle";
    Type3["BIRTHMARK"] = "birthmark";
    Type3["SCAR"] = "scar";
    Type3["STRETCH_MARK"] = "stretch_mark";
    Type3["TATTOO"] = "tattoo";
    Type3["PIGMENTATION"] = "pigmentation";
    Type3["OTHER"] = "other";
  })(Type2 = MarkNamespace2.Type || (MarkNamespace2.Type = {}));
  MarkNamespace2.TYPE_ORDER = [
    "mole" /* MOLE */,
    "freckle" /* FRECKLE */,
    "birthmark" /* BIRTHMARK */,
    "scar" /* SCAR */,
    "stretch_mark" /* STRETCH_MARK */,
    "tattoo" /* TATTOO */,
    "pigmentation" /* PIGMENTATION */,
    "other" /* OTHER */
  ];
})(MarkNamespace || (MarkNamespace = {}));
var BodyArea = /* @__PURE__ */ ((BodyArea2) => {
  BodyArea2["HEAD"] = "head";
  BodyArea2["TORSO"] = "torso";
  BodyArea2["LEFT_ARM"] = "left_arm";
  BodyArea2["RIGHT_ARM"] = "right_arm";
  BodyArea2["LEFT_HAND"] = "left_hand";
  BodyArea2["RIGHT_HAND"] = "right_hand";
  BodyArea2["LEFT_LEG"] = "left_leg";
  BodyArea2["RIGHT_LEG"] = "right_leg";
  BodyArea2["LEFT_FOOT"] = "left_foot";
  BodyArea2["RIGHT_FOOT"] = "right_foot";
  BodyArea2["BACK"] = "back";
  return BodyArea2;
})(BodyArea || {});
var BODY_AREA_ORDER = [
  "head" /* HEAD */,
  "torso" /* TORSO */,
  "back" /* BACK */,
  "left_arm" /* LEFT_ARM */,
  "right_arm" /* RIGHT_ARM */,
  "left_hand" /* LEFT_HAND */,
  "right_hand" /* RIGHT_HAND */,
  "left_leg" /* LEFT_LEG */,
  "right_leg" /* RIGHT_LEG */,
  "left_foot" /* LEFT_FOOT */,
  "right_foot" /* RIGHT_FOOT */
];
var UNCATEGORIZED_LOCATION = "uncategorized";
var BodyType = /* @__PURE__ */ ((BodyType2) => {
  BodyType2["BODY_TYPE_1"] = "body_type_1";
  BodyType2["BODY_TYPE_2"] = "body_type_2";
  BodyType2["BODY_TYPE_3"] = "body_type_3";
  return BodyType2;
})(BodyType || {});

// src/utils/pointName.ts
var MOLE_PREFIXES = ["Mole", "Moley", "Mol", "Spot"];
var PUNNY_NAME_ROOTS = [
  "Lex",
  "Drew",
  "Sam",
  "Max",
  "Finn",
  "Blake",
  "Morgan",
  "Quinn",
  "Reese",
  "Jordan",
  "Casey",
  "Avery",
  "Riley",
  "Skyler",
  "Jamie",
  "Alex",
  "Charlie",
  "Taylor",
  "Parker",
  "Sage",
  "River"
];
var MOLE_COLOR_ADJECTIVES = [
  "Dark",
  "Midnight",
  "Charcoal",
  "Sandy",
  "Light",
  "Pale",
  "Dusky",
  "Ebony",
  "Mocha",
  "Cocoa",
  "Freckled",
  "Dappled",
  "Speckled"
];
var MOLE_SHAPE_ADJECTIVES = [
  "Flat",
  "Raised",
  "Mini",
  "Tiny",
  "Round",
  "Oval"
];
var MOLE_DESCRIPTIVE_NOUNS = [
  "Bluff",
  "Shadow",
  "Vinyl",
  "Pancake",
  "Peak",
  "Dome",
  "Dot",
  "Speck",
  "Mark",
  "Blot",
  "Fleck",
  "Patch",
  "Nub",
  "Bump"
];
var MOLE_THE_PREFIX_NOUNS = [
  "Bluff",
  "Pancake",
  "Shadow",
  "Dome",
  "Peak",
  "Nub",
  "Mark",
  "Squad",
  "Gang",
  "Crew",
  "Bunch",
  "Cluster",
  "Trio",
  "Duo"
];
var FOOD_ADJECTIVES = [
  "Chocolate",
  "Cocoa",
  "Cookie",
  "Cinnamon",
  "Peppermint",
  "Poppy",
  "Graham",
  "Caramel",
  "Butterscotch",
  "Honey",
  "Maple",
  "Nutmeg",
  "Licorice",
  "Mocha",
  "Espresso",
  "Toffee",
  "Fudge"
];
var FOOD_NOUNS = [
  "Chip",
  "Puff",
  "Patty",
  "Seed",
  "Crumb",
  "Bun",
  "Swirl",
  "Drop",
  "Nugget",
  "Bit",
  "Bite",
  "Morsel",
  "Drizzle",
  "Dust"
];
var ASPIRATIONAL_NAMES = [
  "Star",
  "Belle",
  "Grace",
  "Icon",
  "Gem",
  "Pearl",
  "Diamond",
  "Velvet",
  "Satin",
  "Silk",
  "Royal",
  "Noble",
  "Diva",
  "Legend",
  "Charm",
  "Glow",
  "Spark",
  "Shine",
  "Blaze",
  "Ember"
];
var QUIRKY_TITLES = ["Sir", "Lord", "Dame", "Captain", "The", "Doctor"];
var QUIRKY_SPOT_ROOTS = ["Spot", "Dot", "Speck", "Mole", "Mark", "Blot"];
var QUIRKY_SUFFIXES = [
  "-a-Lot",
  "father",
  "tacular",
  "ie",
  "ington",
  "worth",
  "stein",
  "ovich",
  "heimer",
  "ington III"
];
var BODY_PARTS = [
  "Shoulder",
  "Neck",
  "Cheek",
  "Arm",
  "Belly",
  "Foot",
  "Knee",
  "Elbow",
  "Wrist",
  "Ankle",
  "Hip",
  "Back",
  "Chest"
];
var LOCATION_SURNAME_PREFIXES = ["Mc", "Von", "De", "O'", "La"];
var LOCATION_SURNAME_ROOTS = [
  "Spot",
  "Dot",
  "Mark",
  "Speck",
  "Fleck",
  "Blot",
  "Patch",
  "Nub",
  "Bump",
  "Mole",
  "Point",
  "Pin"
];
var MOLE_VIBES = [
  "punny",
  "descriptive",
  "food",
  "celebrity",
  "quirky",
  "location"
];
function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}
var MOLE_BANKS = {
  prefixes: MOLE_PREFIXES,
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: MOLE_COLOR_ADJECTIVES,
  shapeAdjectives: MOLE_SHAPE_ADJECTIVES,
  descriptiveNouns: MOLE_DESCRIPTIVE_NOUNS,
  theNouns: MOLE_THE_PREFIX_NOUNS,
  foodAdjectives: FOOD_ADJECTIVES,
  foodNouns: FOOD_NOUNS,
  aspirational: ASPIRATIONAL_NAMES,
  quirkyRoots: QUIRKY_SPOT_ROOTS,
  locationRoots: LOCATION_SURNAME_ROOTS
};
var FRECKLE_BANKS = {
  prefixes: ["Freckle", "Speck", "Dot", "Sprinkle"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: ["Sunny", "Golden", "Honey", "Amber", "Dusty", "Warm", "Copper", "Ginger"],
  shapeAdjectives: ["Tiny", "Mini", "Fine", "Scattered", "Little", "Dainty"],
  descriptiveNouns: ["Speck", "Dust", "Kiss", "Spark", "Fleck", "Dot", "Grain", "Mote"],
  theNouns: ["Sprinkle", "Constellation", "Dusting", "Cluster", "Kiss", "Sparkle"],
  foodAdjectives: ["Cinnamon", "Nutmeg", "Honey", "Ginger", "Sesame", "Brown Sugar", "Maple"],
  foodNouns: ["Dust", "Sprinkle", "Seed", "Crumb", "Speck", "Sugar"],
  aspirational: ["Sunny", "Goldie", "Amber", "Honey", "Glimmer", "Spark"],
  quirkyRoots: ["Speck", "Dot", "Freckle", "Dust", "Spark"],
  locationRoots: ["Speck", "Dot", "Dust", "Kiss", "Spark", "Freckle"]
};
var BIRTHMARK_BANKS = {
  prefixes: ["Mark", "Stamp", "Berry", "Bloom"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: ["Wine", "Rose", "Port", "Berry", "Blush", "Russet", "Cranberry", "Plum"],
  shapeAdjectives: ["Soft", "Bold", "Round", "Broad", "Little", "Painted"],
  descriptiveNouns: ["Stamp", "Island", "Bloom", "Seal", "Patch", "Badge", "Splash", "Map"],
  theNouns: ["Island", "Stamp", "Bloom", "Badge", "Map", "Seal"],
  foodAdjectives: ["Cherry", "Raspberry", "Strawberry", "Wine", "Port", "Cranberry"],
  foodNouns: ["Stain", "Drop", "Jam", "Splash", "Bite", "Kiss"],
  aspirational: ["Rose", "Ruby", "Bloom", "Scarlet", "Belle", "Jewel"],
  quirkyRoots: ["Stamp", "Mark", "Bloom", "Berry", "Island"],
  locationRoots: ["Mark", "Stamp", "Bloom", "Island", "Berry", "Seal"]
};
var SCAR_BANKS = {
  prefixes: ["Scar", "Seam", "Silver", "Stitch"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: ["Silver", "Pale", "Pearl", "Ivory", "Frost", "White", "Moonlit"],
  shapeAdjectives: ["Fine", "Long", "Thin", "Quiet", "Slim", "Faint"],
  descriptiveNouns: ["Line", "Seam", "Thread", "Stitch", "Trail", "Ridge", "Story", "Slash"],
  theNouns: ["Seam", "Stitch", "Line", "Trail", "Story", "Thread"],
  foodAdjectives: ["Vanilla", "Coconut", "Cream", "Pearl", "Sugar"],
  foodNouns: ["Stripe", "Drizzle", "Thread", "Line", "Swirl"],
  aspirational: ["Silver", "Sterling", "Ivory", "Pearl", "Valor", "Knight"],
  quirkyRoots: ["Seam", "Stitch", "Scar", "Line", "Thread"],
  locationRoots: ["Seam", "Line", "Stitch", "Scar", "Thread", "Trail"]
};
var STRETCH_BANKS = {
  prefixes: ["Stripe", "Ribbon", "Tiger", "Silk"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: ["Silver", "Blush", "Pearl", "Pale", "Rose", "Satin", "Moon"],
  shapeAdjectives: ["Long", "Wavy", "Fine", "Soft", "Slim", "Flowing"],
  descriptiveNouns: ["Stripe", "Ribbon", "Wave", "Silk", "Streak", "Band", "Ripple", "Line"],
  theNouns: ["Ribbon", "Stripe", "Wave", "Streak", "Ripple", "Tiger"],
  foodAdjectives: ["Vanilla", "Strawberry", "Cream", "Marble", "Coconut"],
  foodNouns: ["Stripe", "Swirl", "Ribbon", "Drizzle", "Ripple"],
  aspirational: ["Silk", "Satin", "Luna", "Ripple", "Aura", "Grace"],
  quirkyRoots: ["Stripe", "Ribbon", "Wave", "Tiger", "Silk"],
  locationRoots: ["Stripe", "Ribbon", "Wave", "Silk", "Streak", "Tiger"]
};
var TATTOO_BANKS = {
  prefixes: ["Ink", "Flash", "Needle", "Shade"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: ["Black", "Bold", "Midnight", "Neon", "Classic", "Vivid", "Ink"],
  shapeAdjectives: ["Fine", "Bold", "Tiny", "Script", "Lined", "Shaded"],
  descriptiveNouns: ["Flash", "Line", "Needle", "Shade", "Script", "Mark", "Outline", "Piece"],
  theNouns: ["Flash", "Needle", "Outline", "Script", "Piece", "Shade"],
  foodAdjectives: ["Espresso", "Licorice", "Blackberry", "Coffee", "Cola"],
  foodNouns: ["Drop", "Shot", "Bean", "Splash", "Bite"],
  aspirational: ["Indigo", "Raven", "Onyx", "Jet", "Noir", "Ace"],
  quirkyRoots: ["Ink", "Flash", "Needle", "Shade", "Script"],
  locationRoots: ["Ink", "Flash", "Needle", "Shade", "Script", "Line"]
};
var PIGMENT_BANKS = {
  prefixes: ["Patch", "Blush", "Wash", "Tint"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: ["Rosy", "Warm", "Dusky", "Olive", "Amber", "Sunlit", "Honey"],
  shapeAdjectives: ["Soft", "Wide", "Faint", "Mottled", "Gentle", "Painted"],
  descriptiveNouns: ["Wash", "Blush", "Tint", "Patch", "Glow", "Veil", "Stain", "Shade"],
  theNouns: ["Blush", "Wash", "Veil", "Glow", "Tint", "Shade"],
  foodAdjectives: ["Peach", "Apricot", "Honey", "Caramel", "Rose", "Saffron"],
  foodNouns: ["Blush", "Wash", "Glaze", "Stain", "Drop"],
  aspirational: ["Blush", "Aurora", "Glow", "Honey", "Dawn", "Sol"],
  quirkyRoots: ["Blush", "Tint", "Wash", "Patch", "Glow"],
  locationRoots: ["Blush", "Tint", "Wash", "Patch", "Glow", "Shade"]
};
var OTHER_BANKS = {
  prefixes: ["Mark", "Spot", "Dot", "Spec"],
  punnyRoots: PUNNY_NAME_ROOTS,
  colorAdjectives: MOLE_COLOR_ADJECTIVES,
  shapeAdjectives: MOLE_SHAPE_ADJECTIVES,
  descriptiveNouns: ["Mark", "Spot", "Dot", "Speck", "Patch", "Note", "Point"],
  theNouns: ["Mark", "Spot", "Note", "Point", "Patch", "Dot"],
  foodAdjectives: FOOD_ADJECTIVES,
  foodNouns: ["Spot", "Dot", "Bit", "Drop", "Speck", "Chip"],
  aspirational: ASPIRATIONAL_NAMES,
  quirkyRoots: ["Spot", "Dot", "Mark", "Speck", "Note"],
  locationRoots: ["Spot", "Dot", "Mark", "Speck", "Point", "Note"]
};
var BANKS_BY_TYPE = {
  [MarkNamespace.Type.MOLE]: MOLE_BANKS,
  [MarkNamespace.Type.FRECKLE]: FRECKLE_BANKS,
  [MarkNamespace.Type.BIRTHMARK]: BIRTHMARK_BANKS,
  [MarkNamespace.Type.SCAR]: SCAR_BANKS,
  [MarkNamespace.Type.STRETCH_MARK]: STRETCH_BANKS,
  [MarkNamespace.Type.TATTOO]: TATTOO_BANKS,
  [MarkNamespace.Type.PIGMENTATION]: PIGMENT_BANKS,
  [MarkNamespace.Type.OTHER]: OTHER_BANKS
};
function generatePunnyName(banks) {
  return `${pick(banks.prefixes)} ${pick(banks.punnyRoots)}`;
}
function generateDescriptiveName(banks) {
  if (Math.random() < 0.4) {
    return `The ${pick(banks.theNouns)}`;
  }
  const adj = Math.random() < 0.5 ? pick(banks.colorAdjectives) : pick(banks.shapeAdjectives);
  return `${adj} ${pick(banks.descriptiveNouns)}`;
}
function generateFoodName(banks) {
  return `${pick(banks.foodAdjectives)} ${pick(banks.foodNouns)}`;
}
function generateCelebrityName(banks) {
  return `${pick(banks.colorAdjectives)} ${pick(banks.aspirational)}`;
}
function generateQuirkyName(banks) {
  const title = pick(QUIRKY_TITLES);
  const root = pick(banks.quirkyRoots);
  const suffix = pick(QUIRKY_SUFFIXES);
  const rootForm = suffix.includes("a-Lot") ? `${root}s` : root;
  return `${title} ${rootForm}${suffix}`;
}
function generateLocationName(banks, location) {
  const bodyPart = location ? location.charAt(0).toUpperCase() + location.slice(1).toLowerCase() : pick(BODY_PARTS);
  return `${bodyPart} ${pick(LOCATION_SURNAME_PREFIXES)}${pick(banks.locationRoots)}`;
}
function generateFromBanks(banks, locationLabel) {
  const chosenVibe = MOLE_VIBES[Math.floor(Math.random() * MOLE_VIBES.length)];
  switch (chosenVibe) {
    case "punny":
      return generatePunnyName(banks);
    case "descriptive":
      return generateDescriptiveName(banks);
    case "food":
      return generateFoodName(banks);
    case "celebrity":
      return generateCelebrityName(banks);
    case "quirky":
      return generateQuirkyName(banks);
    case "location":
      return generateLocationName(banks, locationLabel);
    default:
      return generateDescriptiveName(banks);
  }
}
var BODY_AREA_LABELS = {
  ["left_arm" /* LEFT_ARM */]: "Left arm",
  ["left_hand" /* LEFT_HAND */]: "Left hand",
  ["right_arm" /* RIGHT_ARM */]: "Right arm",
  ["right_hand" /* RIGHT_HAND */]: "Right hand",
  ["left_leg" /* LEFT_LEG */]: "Left leg",
  ["left_foot" /* LEFT_FOOT */]: "Left foot",
  ["right_leg" /* RIGHT_LEG */]: "Right leg",
  ["right_foot" /* RIGHT_FOOT */]: "Right foot",
  ["torso" /* TORSO */]: "Torso",
  ["head" /* HEAD */]: "Head",
  ["back" /* BACK */]: "Back"
};
function generateMarkName(type, area) {
  return generateFromBanks(BANKS_BY_TYPE[type], BODY_AREA_LABELS[area]);
}

// src/colors.ts
var lightColors = {
  // Primary Palette
  primary: "#2C6E8F",
  primaryLight: "#4A8FB3",
  primaryDark: "#1E4F6B",
  // Secondary Palette
  secondary: "#4A9E8F",
  secondaryLight: "#6FB8AA",
  secondaryDark: "#2E7D6F",
  // Accent
  accent: "#E86A5F",
  accentLight: "#FF8A7A",
  accentDark: "#C04A3F",
  // Background & Surfaces
  background: "#F8FAFC",
  surface: "#FFFFFF",
  surfaceVariant: "#F1F5F9",
  // Text
  textPrimary: "#1A2E3C",
  textSecondary: "#5A6F7F",
  textTertiary: "#94A3B8",
  textDisabled: "#CBD5E1",
  // Status Colors
  success: "#059669",
  successLight: "#10B981",
  warning: "#D97706",
  warningLight: "#F59E0B",
  error: "#DC2626",
  errorLight: "#EF4444",
  info: "#2563EB",
  infoLight: "#3B82F6",
  // Mole Status Pins
  moleNew: "#1A2E3C",
  moleEdit: "#E86A5F",
  /** 3D mark sphere. Mid steel blue so it reads on the pale mannequin without looking black. */
  markSphere: "#5A7E9A",
  // Point Risk Levels
  riskNormal: "#4A9E8F",
  riskMonitor: "#3B82F6",
  riskWarning: "#D97706",
  riskHigh: "#E86A5F",
  riskCritical: "#DC2626",
  // V2 Mark Types
  markMole: "#4A9E8F",
  markFreckle: "#D97706",
  markBirthmark: "#7C3AED",
  markScar: "#64748B",
  markStretchMark: "#DB2777",
  markTattoo: "#2563EB",
  markPigmentation: "#B45309",
  markOther: "#0D9488",
  // UI Elements
  divider: "#E2E8F0",
  border: "#E2E8F0",
  overlay: "rgba(0, 0, 0, 0.5)",
  shadow: "#000000",
  // Gradients (for LinearGradient)
  gradientPrimary: ["#2C6E8F", "#4A9E8F"],
  gradientSurface: ["#F8FAFC", "#E2E8F0"]
};
var darkColors = {
  // Primary Palette
  primary: "#5FA3C4",
  primaryLight: "#7FBAD6",
  primaryDark: "#3F7A99",
  // Secondary Palette
  secondary: "#6FBBA8",
  secondaryLight: "#8FCDBD",
  secondaryDark: "#4F9A87",
  // Accent
  accent: "#FF8A7A",
  accentLight: "#FFA599",
  accentDark: "#D66A5A",
  // Background & Surfaces
  background: "#121A22",
  surface: "#1E2937",
  surfaceVariant: "#26333F",
  // Text
  textPrimary: "#F1F5F9",
  textSecondary: "#94A3B8",
  textTertiary: "#64748B",
  textDisabled: "#475569",
  // Status Colors
  success: "#10B981",
  successLight: "#34D399",
  warning: "#F59E0B",
  warningLight: "#FBBF24",
  error: "#EF4444",
  errorLight: "#F87171",
  info: "#3B82F6",
  infoLight: "#60A5FA",
  // Mole Status Pins
  moleNew: "#F1F5F9",
  moleEdit: "#FF8A7A",
  /** 3D mark sphere. Lighter than the light theme so the dark canvas does not make it look like a hole. */
  markSphere: "#8EB3CC",
  // Point Risk Levels
  riskNormal: "#6FBBA8",
  riskMonitor: "#7AB7F7",
  riskWarning: "#F59E0B",
  riskHigh: "#FF8A7A",
  riskCritical: "#EF4444",
  // V2 Mark Types
  markMole: "#6FBBA8",
  markFreckle: "#F59E0B",
  markBirthmark: "#A78BFA",
  markScar: "#94A3B8",
  markStretchMark: "#F472B6",
  markTattoo: "#7AB7F7",
  markPigmentation: "#D97706",
  markOther: "#2DD4BF",
  // UI Elements
  divider: "#2D3A48",
  border: "#2D3A48",
  overlay: "rgba(0, 0, 0, 0.7)",
  shadow: "#000000",
  // Gradients
  gradientPrimary: ["#1E2937", "#2C3E50"],
  gradientSurface: ["#121A22", "#1E2937"]
};

// src/fonts.ts
var fontStacks = {
  sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
};
var fontFamilyNative = {
  ios: { sans: "system-ui", mono: "ui-monospace" },
  android: { sans: "Roboto", mono: "monospace" },
  web: { sans: fontStacks.sans, mono: fontStacks.mono }
};

// src/markShapes.ts
var Type = MarkNamespace.Type;
var MARK_SHAPES = {
  [Type.MOLE]: {
    viewBox: [0, 0, 100, 100],
    d: "M16 50A34 34 0 1 0 84 50A34 34 0 1 0 16 50Z"
  },
  [Type.FRECKLE]: {
    viewBox: [0, 0, 100, 100],
    d: [
      "M19 58A9 9 0 1 0 37 58A9 9 0 1 0 19 58Z",
      "M32 30A8 8 0 1 0 48 30A8 8 0 1 0 32 30Z",
      "M46 48A6 6 0 1 0 58 48A6 6 0 1 0 46 48Z",
      "M57 26A9 9 0 1 0 75 26A9 9 0 1 0 57 26Z",
      "M68 48A8 8 0 1 0 84 48A8 8 0 1 0 68 48Z",
      "M61 70A7 7 0 1 0 75 70A7 7 0 1 0 61 70Z",
      "M38 76A8 8 0 1 0 54 76A8 8 0 1 0 38 76Z"
    ].join("")
  },
  [Type.BIRTHMARK]: {
    viewBox: [0, 0, 100, 100],
    d: "M50 14C66 10 78 16 86 30C96 46 94 64 82 76C70 90 54 94 40 88C24 82 8 68 12 50C16 32 30 18 50 14Z"
  },
  [Type.SCAR]: {
    viewBox: [0, 0, 200, 48],
    d: "M18 26C48 14 92 16 128 14C156 12 178 18 186 24C178 32 156 38 128 36C92 38 48 36 18 26Z"
  },
  [Type.STRETCH_MARK]: {
    viewBox: [0, 0, 200, 140],
    d: [
      "M22 42C54 28 96 34 132 26C158 20 178 28 186 38C172 48 148 42 122 48C88 54 52 48 22 42Z",
      "M14 80C48 66 92 74 130 64C158 56 178 68 190 78C174 90 148 82 116 86C78 92 42 86 14 80Z",
      "M42 112C72 100 108 108 138 100C158 94 172 102 178 112C164 122 146 116 118 120C88 126 58 120 42 112Z"
    ].join("")
  },
  [Type.TATTOO]: {
    viewBox: [0, 0, 100, 100],
    d: "M50 8L61.8 38.2L94 40.2L68.4 59.6L78 90L50 73.2L22 90L31.6 59.6L6 40.2L38.2 38.2Z"
  },
  [Type.PIGMENTATION]: {
    viewBox: [0, 0, 100, 100],
    d: "M50 12C68 8 84 20 90 38C96 56 88 74 72 86C58 96 40 94 26 82C10 68 8 46 20 30C30 16 36 14 50 12Z"
  },
  [Type.OTHER]: {
    viewBox: [0, 0, 100, 100],
    d: "M10 50A40 40 0 1 0 90 50A40 40 0 1 0 10 50ZM28 50A22 22 0 1 1 72 50A22 22 0 1 1 28 50Z"
  }
};
var MARK_TYPE_COLOR_KEY = {
  [Type.MOLE]: "markMole",
  [Type.FRECKLE]: "markFreckle",
  [Type.BIRTHMARK]: "markBirthmark",
  [Type.SCAR]: "markScar",
  [Type.STRETCH_MARK]: "markStretchMark",
  [Type.TATTOO]: "markTattoo",
  [Type.PIGMENTATION]: "markPigmentation",
  [Type.OTHER]: "markOther"
};
function markTypeColor(type, colors) {
  return colors[MARK_TYPE_COLOR_KEY[type]];
}

// src/bridge/init.ts
var parseEngineInitParams = (url) => {
  const initParams = {
    theme: "light",
    bodyType: "body_type_1" /* BODY_TYPE_1 */
  };
  const theme = url.get("theme");
  if (theme === "light" || theme === "dark") initParams.theme = theme;
  const bodyType = url.get("bodyType");
  if (bodyType === "body_type_1" /* BODY_TYPE_1 */ || bodyType === "body_type_2" /* BODY_TYPE_2 */ || bodyType === "body_type_3" /* BODY_TYPE_3 */)
    initParams.bodyType = bodyType;
  return initParams;
};

// src/bridge/messages.ts
var EngineIncomingMessageType = /* @__PURE__ */ ((EngineIncomingMessageType2) => {
  EngineIncomingMessageType2["SET_THEME"] = "SET_THEME";
  EngineIncomingMessageType2["SET_MARKER_STYLE"] = "SET_MARKER_STYLE";
  EngineIncomingMessageType2["SET_POINTS"] = "SET_POINTS";
  EngineIncomingMessageType2["SET_ENGINE_STATE"] = "SET_ENGINE_STATE";
  EngineIncomingMessageType2["ZOOM_IN_LOCATION"] = "ZOOM_IN_LOCATION";
  EngineIncomingMessageType2["ZOOM_IN_POINT"] = "ZOOM_IN_POINT";
  EngineIncomingMessageType2["RESET_CAMERA"] = "RESET_CAMERA";
  return EngineIncomingMessageType2;
})(EngineIncomingMessageType || {});
var EngineOutgoingMessageType = /* @__PURE__ */ ((EngineOutgoingMessageType2) => {
  EngineOutgoingMessageType2["ERROR"] = "ERROR";
  EngineOutgoingMessageType2["ENGINE_READY"] = "ENGINE_READY";
  EngineOutgoingMessageType2["LOG"] = "LOG";
  EngineOutgoingMessageType2["TAP_ON_POINT"] = "TAP_ON_POINT";
  EngineOutgoingMessageType2["TAP_ON_BODY"] = "TAP_ON_BODY";
  EngineOutgoingMessageType2["DOUBLE_TAP_ON_BODY"] = "DOUBLE_TAP_ON_BODY";
  EngineOutgoingMessageType2["TAP_OUTSIDE"] = "TAP_OUTSIDE";
  return EngineOutgoingMessageType2;
})(EngineOutgoingMessageType || {});
export {
  BODY_AREA_ORDER,
  BodyArea,
  BodyType,
  EngineIncomingMessageType,
  EngineOutgoingMessageType,
  MARK_SHAPES,
  MARK_TYPE_COLOR_KEY,
  MarkNamespace,
  PointRiskLevel,
  UNCATEGORIZED_LOCATION,
  darkColors,
  fontFamilyNative,
  fontStacks,
  generateMarkName,
  lightColors,
  markTypeColor,
  parseEngineInitParams
};
